import React, { memo } from 'react';
import { ListItem, ListItemText, Box, Switch } from '@mui/material';
import TooltipHelpButton from '../../buttons/TooltipHelpButton/TooltipHelpButton';
import WarningButton from '../../buttons/WarningButton';

const SwitchListItem = memo(({ checked, text, onChange, toolTip, warning, ...other }) => {
    return (
        <ListItem
            {...other}
        >
            <ListItemText>
                {text}
                {toolTip && <TooltipHelpButton title={toolTip} />}
                {warning && <WarningButton title={warning} />}
            </ListItemText>
            <Box>
                <Switch
                    checked={checked}
                    onChange={onChange}
                    color='primary'
                />
            </Box>
        </ListItem>
    );
}
);

export default SwitchListItem;